import { SVGProps } from "react";

export default function AllChainIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={props.width ? props.width : "24"}
      height={props.height ? props.height : "24"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
    >
      <path
        d="M19.07 14.2416C18.78 14.5316 18.32 14.5316 18.04 14.2416C17.75 13.9516 17.75 13.4916 18.04 13.2116C20.04 11.2116 20.04 7.96156 18.04 5.97156C16.04 3.98156 12.79 3.97156 10.8 5.97156C8.81003 7.97156 8.80003 11.2216 10.8 13.2116C11.09 13.5016 11.09 13.9616 10.8 14.2416C10.51 14.5316 10.05 14.5316 9.77003 14.2416C7.20003 11.6716 7.20003 7.49156 9.77003 4.93156C12.34 2.37156 16.52 2.36156 19.08 4.93156C21.64 7.50156 21.64 11.6716 19.07 14.2416Z"
        fill="white"
      />
      <path
        d="M4.92997 9.75656C5.21997 9.46656 5.67997 9.46656 5.95997 9.75656C6.24997 10.0466 6.24997 10.5066 5.95997 10.7866C3.95997 12.7866 3.95997 16.0366 5.95997 18.0266C7.95997 20.0166 11.21 20.0266 13.2 18.0266C15.19 16.0266 15.2 12.7766 13.2 10.7866C12.91 10.4966 12.91 10.0366 13.2 9.75656C13.49 9.46656 13.95 9.46656 14.23 9.75656C16.8 12.3266 16.8 16.5066 14.23 19.0666C11.66 21.6266 7.47997 21.6366 4.91997 19.0666C2.35997 16.4966 2.35997 12.3266 4.92997 9.75656Z"
        fill="white"
      />
    </svg>
  );
}
